import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from '../../../Components/Modal/StatefulModal';

import CreateEditWorkshopForm from './CreateEditWorkshopForm';

export default class AddWorkshopModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    isOpen: PropTypes.bool,
    trigger: PropTypes.element,
    courseId: PropTypes.string,
    variables: PropTypes.object,
  };
  static defaultProps = {
    isEdit: false,
  };
  render() {
    const { variables, isEdit, trigger, courseId } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>
              {isEdit ? 'Edit Workshop Information' : 'Create New Workshop'}
            </Modal.Header>
            <Modal.Content>
              <CreateEditWorkshopForm
                onComplete={closeModal}
                onCancelled={closeModal}
                searchVariables={variables}
                courseId={courseId}
              />
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
